import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export var erpMethodApi = createApi({
    reducerPath: "methodServiceApi",
    baseQuery: fetchBaseQuery({
        baseUrl: (window === null || window === void 0 ? void 0 : window.baseUrl) + "api/method/",
        credentials: "include",
    }),
    tagTypes: ['exec'],
    endpoints: function (build) { return ({
        getReportApi: build.query({
            query: function (_a) {
                var url = _a.url, report_name = _a.report_name;
                return url + "?report_name=" + report_name;
            },
        }),
        execMethodApi: build.query({
            query: function (_a) {
                var method = _a.method, body = _a.body;
                return ({
                    url: "".concat(method),
                    method: 'POST',
                    body: body
                });
            },
            providesTags: ['exec']
        }),
        execMutationApi: build.mutation({
            query: function (_a) {
                var method = _a.method, body = _a.body;
                return ({
                    url: "".concat(method),
                    method: 'POST',
                    body: body
                });
            },
            invalidatesTags: ['exec']
        })
    }); },
});
export var useExecMethodApiQuery = erpMethodApi.useExecMethodApiQuery;
export default erpMethodApi;
